import { Box } from '@mui/material'
import React, { useMemo } from 'react'
import FilterSection from './FilterSection'
import TripTable from './TripTable'
import BkgType from './BkgType'
import TripSeatFare from './TripSeatFare'
import PassengerSeat from './PassengerSeat'
import PickUpAndDropOff from './PickUpAndDropOff'
import BottomSection from './BottomSection'
import { calcSeatFare } from '../constant'
import { useLoadTripDetails } from '../../../hook/useLoadTripDetails'

const RightSection = (props) => {
    const { filterOptions, filterValues, setFilterOptions, setFilterValues, setTableData, tableData = [], bkgDeatails, setBkgDetails, filterOpt, setFilterOpt,
        handleReset = () => { },
        selectedSeat = [],
        handleResetTripData = () => { },
        setSelectedSeat = () => { },
    } = props;
    const { loadTripDetails } = useLoadTripDetails();

    let tripTotalAmt = useMemo(() => {
        return calcSeatFare(selectedSeat, bkgDeatails)
    }, [selectedSeat, bkgDeatails?.tripDetails, bkgDeatails?.servicecharge, bkgDeatails?.pickUp, bkgDeatails.dropOff])

    const handleResetTrip = (trip) => {
        handleResetTripData()
        loadTripDetails({ tripDetails: trip, setBkgDetails, setFilterOpt, setSelectedSeat, deleteCache: true });
    }
    return (
        <Box className='right_Section'>
            <Box>
                <FilterSection
                    bkgDeatails={bkgDeatails}
                    filterOptions={filterOptions}
                    filterValues={filterValues}
                    setFilterOptions={setFilterOptions}
                    setFilterValues={setFilterValues}
                    setTableData={setTableData}
                    handleReset={handleReset}
                    handleResetTripData={handleResetTripData}
                    setBkgDetails={setBkgDetails}
                    setFilterOpt={setFilterOpt}
                    setSelectedSeat={setSelectedSeat}
                />
                <TripTable tableData={tableData} setBkgDetails={setBkgDetails}
                    setFilterOpt={setFilterOpt}
                    handleResetTripData={handleResetTripData}
                    setSelectedSeat={setSelectedSeat}
                    bkgDeatails={bkgDeatails}
                />
            </Box>
            {Object.keys(bkgDeatails.tripDetails).length !== 0 &&
                <>

                    <TripSeatFare
                        tripTotalAmt={tripTotalAmt}
                        bkgDeatails={bkgDeatails}
                        setBkgDetails={setBkgDetails}
                        setFilterOpt={setFilterOpt}
                        filterOpt={filterOpt}
                        selectedSeat={selectedSeat}
                        setSelectedSeat={setSelectedSeat}
                    />
                    <BkgType
                        bkgDeatails={bkgDeatails}
                        setBkgDetails={setBkgDetails}
                        filterOpt={filterOpt}
                        tableData={tableData}
                        setFilterOpt={setFilterOpt}

                    />
                    {selectedSeat.length !== 0 &&
                        <Box className='passengerSeat_page'>
                            {selectedSeat.map((obj, index) => (
                                <PassengerSeat
                                    obj={obj}
                                    index={index}
                                    filterOpt={filterOpt}
                                    selectedSeat={selectedSeat}
                                    setSelectedSeat={setSelectedSeat}
                                    bkgDeatails={bkgDeatails}
                                />
                            ))}
                        </Box>
                    }
                    <PickUpAndDropOff filterOpt={filterOpt} bkgDeatails={bkgDeatails} setBkgDetails={setBkgDetails} selectedSeat={selectedSeat} />
                    <BottomSection bkgDeatails={bkgDeatails} selectedSeat={selectedSeat}
                        tripTotalAmt={tripTotalAmt}
                        filterOpt={filterOpt}
                        setBkgDetails={setBkgDetails}
                        handleResetTrip={() => {
                            handleResetTrip(bkgDeatails.tripDetails)
                        }}
                    />
                </>
            }
        </Box>
    )
}

export default RightSection